module.exports = __webpack_public_path__ + "img/green-phone.ebe83c55.png";